import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { type AuthUser } from "wasp/auth";
import DefaultLayout from "../../layout/DefaultLayout";
import Breadcrumb from "../../layout/Breadcrumb";
import FirmsTab from "./FirmsTab";
import OffersTab from "./OffersTab";

type Tab = "firms" | "offers";

export default function AdminComparatorPage({ user }: { user: AuthUser }) {
  const [tab, setTab] = useState<Tab>("firms");
  const navigate = useNavigate();

  useEffect(() => {
    if (!user.isAdmin) {
      navigate("/dashboard");
    }
  }, [user, navigate]);

  return (
    <DefaultLayout user={user}>
      <Breadcrumb pageName="Comparator" />

      <div className="mb-6 flex items-center gap-6 border-b border-border">
        <button
          type="button"
          onClick={() => setTab("firms")}
          className={
            "pb-3 text-sm font-medium transition-colors " +
            (tab === "firms"
              ? "border-b-2 border-primary text-foreground"
              : "text-muted-foreground hover:text-foreground")
          }
        >
          Firms
        </button>
        <button
          type="button"
          onClick={() => setTab("offers")}
          className={
            "pb-3 text-sm font-medium transition-colors " +
            (tab === "offers"
              ? "border-b-2 border-primary text-foreground"
              : "text-muted-foreground hover:text-foreground")
          }
        >
          Offers
        </button>
      </div>

      {tab === "firms" ? <FirmsTab /> : <OffersTab />}
    </DefaultLayout>
  );
}
